import React, {Component} from "react";
import {closeAlert} from "../../../actions/commonsActions";
import {goBack, push} from "connected-react-router";
import {
    COMPANY_ADMIN,
    OPERATOR,
    PAGINATION_DEFAULT_LIMIT,
    RETAIL,
    SUPER_ADMIN,
    USER,
    USER_ROLES
} from "../../../helpers/constants";
import {connect} from "react-redux";
import {Alert, Card, CardBody, CardTitle} from "reactstrap";
import {I18n} from "../../../I18n/components/loan";
import {fetchTinyCompaniesWithOperator} from "../../../actions/companyActions";
import moment from "moment";
import {fetchStores, fetchTinyStores, fetchTinyStoresWithOperator} from "../../../actions/storesActions";
import LoanOrdersControls from "./LoanOrdersControls";
import LoanOrderList from "./LoanOrderList";
import {fetchLoanOrderList} from "../../../actions/loan/loanOrderActions";
import {fetchLoanOrderStatuses} from "../../../actions/loan/loanOrderStatusActions";
import swal from "sweetalert";
import {isLoansPermission} from "../../../helpers/companyService";

const ORDER_LIST_SIZE_FOR_EXPANDED_VIEW = 10;

class LoanOrders extends Component {

    constructor(props) {
        super(props);
        this.state = {
            retailerIdFilter: '',
            pointIdFilter: '',
            statusFilter: '',
            filter: '',
            dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
            dateTo: moment().format('YYYY-MM-DD'),
            sort: {
                id: 'created',
                desc: true
            },
            expanded: false,
            orderListSize: PAGINATION_DEFAULT_LIMIT,
        };
    }

    componentDidMount() {
        const {lang, authority, companies} = this.props;

        const urlParams = new URLSearchParams(window.location.search);
        const expanded = urlParams.get('expanded') === "true";
        this.setState({
            expanded,
            orderListSize: expanded ? ORDER_LIST_SIZE_FOR_EXPANDED_VIEW : PAGINATION_DEFAULT_LIMIT
        });

        (async () => {
            if (!isLoansPermission(companies[0], authority)) {
                await swal(I18n[lang].contactUsToAccessThis, '', 'error')
                    .then(() => this.props.goBack())
                return;
            }

            await Promise.all(this.getAdditionalDataFetches());
            this.props.fetchLoanOrderStatuses(lang);
            await this.fetchPaginatedData(0);
        })();
    }

    getAdditionalDataFetches = () => {
        const {authority, company} = this.props;
        if (authority === SUPER_ADMIN) {
            return [
                this.props.fetchTinyStores()
            ];
        } else if (company.types.includes(RETAIL)) {
            return authority === COMPANY_ADMIN ? [
                this.props.fetchTinyStores({companyIds: [company.id]})
            ] : [
                this.props.fetchStores({companyId: company.id})
            ];
        } else if (company.types.includes(OPERATOR)) {
            return [
                this.props.fetchTinyCompaniesWithOperator(company.id),
                this.props.fetchTinyStoresWithOperator(company.id)
            ];
        }
    }

    isRetail = () => {
        const {authority, company} = this.props;
        return authority !== SUPER_ADMIN && company.types.includes(RETAIL);
    }

    isUser = () => {
        const {authority} = this.props;
        return authority === USER;
    }

    fetchPaginatedData = async currentPage => {
        const {lang, company, stores} = this.props;
        const {
            retailerIdFilter,
            pointIdFilter,
            statusFilter,
            filter,
            dateFrom,
            dateTo,
            sort,
            orderListSize,
        } = this.state;
        const isRetail = this.isRetail();
        const isUser = this.isUser();

        if (isRetail && isUser && stores.length !== 1) {
            await swal(I18n[lang].userHasToBeConnectedToSingleStore, "", "error");
            return;
        }

        await this.props.fetchLoanOrderList({
            retailerId: isRetail ? company.id : retailerIdFilter,
            pointId: isRetail && isUser ? stores[0].id : pointIdFilter,
            status: statusFilter,
            filter,
            dateFrom,
            dateTo,
            sort: sort ? sort.id + ',' + (sort.desc ? 'desc' : 'asc') : null,
            page: currentPage,
            size: orderListSize,
        }, lang);
        await this.setState({
            currentPage
        });
    };

    setCurrentPage = async currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage)
        });
    };

    onFilterClick = name => {
        return event => {
            const value = event.target.value;
            this.setState(() => {
                return {
                    [`${name}`]: value
                }
            });
        }
    };

    onSortedChange = async sort => {
        await this.setState({
            sort: {...sort[0]}
        });
        await this.fetchPaginatedData(0);
    }

    onOrderClick = orderId => {
        const {expanded} = this.state;
        this.props.changeLocation(`/dashboard/loan/order/info/${orderId}?expanded=${expanded}`);
    }

    onCreateOrderClick = () => {
        const {expanded} = this.state;
        this.props.changeLocation(`/dashboard/loan/order/create?expanded=${expanded}`);
    }

    getFiltered = async () => {
        await this.fetchPaginatedData(0);
    };

    dateToTimeChange = moment => {
        this.setState({
            dateTo: moment.format('YYYY-MM-DD')
        })
    };

    dateFromTimeChange = moment => {
        this.setState({
            dateFrom: moment.format('YYYY-MM-DD')
        })
    };

    clearFilters = () => {
        this.setState({
            retailerIdFilter: '',
            pointIdFilter: '',
            statusFilter: '',
            filter: '',
            dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
            dateTo: moment().format('YYYY-MM-DD'),
            sort: null,
        }, async () => {
            await this.fetchPaginatedData(0);
        })
    };

    getAccessibleCompaniesOrNull = () => {
        const {authority, company, companies, tinyCompaniesWithOperator} = this.props;
        if (authority === SUPER_ADMIN) return companies;
        else if (company.types.includes(OPERATOR)) return tinyCompaniesWithOperator;
        else return null;
    }

    render() {
        const {
            lang,
            authority,
            loading,
            company,
            tinyStores,
            tinyStoresWithOperator,
            orderStatuses,
            loanOrders,
            pagination
        } = this.props;
        const {
            currentPage,
            retailerIdFilter,
            pointIdFilter,
            statusFilter,
            filter,
            dateFrom,
            dateTo,
            sort,
            expanded,
        } = this.state;

        const companiesList = this.getAccessibleCompaniesOrNull();
        const stores = tinyStores.concat(tinyStoresWithOperator);

        const loanOrderList = loading
            ? <div className="loading">Loading...</div>
            : <LoanOrderList
                authority={authority}
                lang={lang}
                company={company}
                loanOrders={loanOrders}
                onOrderClick={this.onOrderClick}
                currentPage={currentPage}
                setCurrentPage={this.setCurrentPage}
                totalPages={pagination.totalPages}
                sort={sort}
                onSortedChange={this.onSortedChange}
            />

        return (
            <div className={expanded ? "expanded" : null}>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <Card className={expanded ? "expanded" : null}>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-credit-card mr-2"/>
                            {I18n[lang].loanOrders}
                        </div>
                    </CardTitle>

                    <CardBody>
                        <LoanOrdersControls
                            lang={lang}
                            authority={authority}
                            company={company}
                            companies={companiesList}
                            stores={stores}
                            orderStatuses={orderStatuses}
                            retailerIdFilter={retailerIdFilter}
                            pointIdFilter={pointIdFilter}
                            statusFilter={statusFilter}
                            filter={filter}
                            dateFrom={dateFrom}
                            dateTo={dateTo}
                            dateFromTimeChange={this.dateFromTimeChange}
                            dateToTimeChange={this.dateToTimeChange}
                            onFilterClick={this.onFilterClick}
                            getFiltered={this.getFiltered}
                            clearFilters={this.clearFilters}
                            onCreateOrderClick={this.onCreateOrderClick}
                        />
                        {loanOrderList}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchLoanOrderList: (query, lang) => dispatch(fetchLoanOrderList(query, lang)),
        fetchLoanOrderStatuses: (lang) => dispatch(fetchLoanOrderStatuses(lang)),
        fetchTinyCompaniesWithOperator: query => dispatch(fetchTinyCompaniesWithOperator(query)),
        fetchStores: query => dispatch(fetchStores(query)),
        fetchTinyStores: query => dispatch(fetchTinyStores(query)),
        fetchTinyStoresWithOperator: (operatorCompanyId) => dispatch(fetchTinyStoresWithOperator(operatorCompanyId)),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        goBack: () => dispatch(goBack()),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    loanOrders: state.loanOrderList.loanOrderList,
    pagination: state.loanOrderList.pagination,
    loading: state.loanOrderList.loading,
    orderStatuses: state.loanOrderStatuses.loanOrderStatuses,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    companies: state.companiesReducer.companies,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    tinyCompaniesWithOperator: state.tinyCompaniesWithOperatorReducer.tinyCompanies,
    stores: state.storesReducer.stores,
    tinyStores: state.tinyStoresReducer.tinyStores,
    tinyStoresWithOperator: state.tinyStoresWithOperatorReducer.tinyStoresWithOperator,
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(LoanOrders)


// WEBPACK FOOTER //
// ./src/components/Loan/Order/LoanOrders.js